var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewTabV3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66732 2.50004L1.66732 10.5C1.52843 10.6389 1.36176 10.7084 1.16732 10.7084C0.972873 10.7084 0.806207 10.6389 0.667318 10.5C0.528429 10.3612 0.458984 10.191 0.458984 9.98962C0.458984 9.78824 0.528429 9.6181 0.667318 9.47921L8.66732 1.50004H1.62565C1.43121 1.50004 1.26454 1.4306 1.12565 1.29171C0.986762 1.15282 0.917318 0.986152 0.917318 0.791707C0.917318 0.583374 0.986762 0.413235 1.12565 0.28129C1.26454 0.149346 1.43121 0.083374 1.62565 0.083374H10.3757C10.5701 0.083374 10.7368 0.152818 10.8757 0.291707C11.0145 0.430596 11.084 0.597263 11.084 0.791707V9.54171C11.084 9.73615 11.0145 9.90282 10.8757 10.0417C10.7368 10.1806 10.5701 10.25 10.3757 10.25C10.1673 10.25 9.99718 10.1806 9.86523 10.0417C9.73329 9.90282 9.66732 9.73615 9.66732 9.54171V2.50004Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTabV3);
export default __webpack_public_path__ + "static/media/newTabV3.51deeeba.svg";
export { ForwardRef as ReactComponent };